import React, { useEffect, useState } from "react";
import Link from "next/link";
import { ChevronDown, ChevronUp } from "lucide-react";
import MenuItemContent from "./MenuItemContent";

export default function MenuItem({ nav, isActive, setActiveMenu }) {
  const { baslik, items, url, title } = nav || {};

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const toggleMenu = () => {
    if (isMobile) {
      setActiveMenu(isActive ? null : nav.id);
    }
  };

  return (
    <div className="relative group lg:hover:bg-shortTerm transition-all ease-in rounded-50 inline-flex items-center w-full lg:justify-center px-1.5 lg:px-2.5 xl:px-4 py-2 font-medium text-sm gap-2 whitespace-nowrap cursor-pointer">
      <div
        onClick={toggleMenu}
        className="flex items-center justify-between w-full"
      >
        {url === "/" ? (
          <span>{baslik}</span>
        ) : (
          <Link
            href={url || "#"}
            title={title}
            className="capitalize"
            prefetch={false}
          >
            {baslik}
          </Link>
        )}
        {items?.length > 0 && (
          <div>
            {isActive ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </div>
        )}
      </div>
      {items?.length > 0 && (
        <div
          className={`absolute left-0 z-50 w-full pt-1 transition-all ease-in origin-top-right ${
            isActive ? "scale-y-100" : "scale-y-0"
          } lg:group-hover:scale-y-100 top-full`}
        >
          <div className="z-50 flex flex-col w-full overflow-hidden origin-top-right rounded-md shadow-lg min-w-min ring-1 ring-black ring-opacity-5 focus:outline-none">
            {items?.map((item) => (
              <MenuItemContent item={item} key={item.id} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
